import { apiClient } from '../client';

/**
 * Outcome → CRM mapping (W4, B2-crm): which Swoft outcome each dialer outcome
 * is sent as, per customer. GET / PUT
 * /api/integrations/swoft-connect/customers/:id/outcome-mapping (admins).
 */

export interface OutcomeMappingRow {
  outcome: string;
  /** What is sent without a choice; null: nothing, the delivery fails. */
  default: string | null;
  mapped: string | null;
  effective: string | null;
}

export interface OutcomeMappingView {
  outcomes: OutcomeMappingRow[];
  targets: string[];
}

const path = (customerId: string) => `/integrations/swoft-connect/customers/${encodeURIComponent(customerId)}/outcome-mapping`;

export function getOutcomeMapping(customerId: string, signal?: AbortSignal) {
  return apiClient.get<OutcomeMappingView>(path(customerId), { signal });
}

/** `null` brings a row back to its default; rows not sent keep their value. */
export function setOutcomeMapping(customerId: string, mapping: Record<string, string | null>) {
  return apiClient.put<OutcomeMappingView>(path(customerId), { mapping });
}
